document.addEventListener("DOMContentLoaded",()=>{

const widget=document.getElementById("FloatingCart");

const image=document.getElementById("FloatingCartImage");

const count=document.getElementById("FloatingCartCount");

if(!widget)return;

async function updateCart(){

const cart=await fetch("/cart.js?"+Date.now()).then(r=>r.json());

if(cart.item_count>0){

widget.classList.add("show");

count.innerHTML=cart.item_count+" "+(cart.item_count==1?"Item":"Items");

if(cart.items.length){

image.src=cart.items[0].featured_image.url;

}

}else{

widget.classList.remove("show");

}

}

updateCart();

const oldFetch=window.fetch;

window.fetch=async(...args)=>{

const res=await oldFetch(...args);

if(typeof args[0]=="string" && args[0].includes("/cart")){

setTimeout(updateCart,300);

}

return res;

};

});